const autocompleteActionModalFilter = {
  sites: 'Sites',
  users: 'Accountable',
  equipments: 'Equipment Type',
  place: 'Local',
  areas: 'Departments',
  status: 'Status Actions',
  statusMaintenances: 'Status Maintenances',
  maintenanceCreatedBy: 'Maintenance Created By',
};

export default autocompleteActionModalFilter;
